import { useQuery } from "@tanstack/react-query";
import type { SolutionWorkloadPayload } from "@/api/solution-workload";
import { solutionWorkloadKeys } from "@/lib/query";

export type {
  ResourceHours,
  SolutionWorkloadMonth,
  SolutionWorkloadPayload,
} from "@/api/solution-workload";

async function fetchSolutionWorkload(solutionId: string): Promise<SolutionWorkloadPayload> {
  const res = await fetch(`/api/dashboard/solutions/${solutionId}/workload`);
  if (!res.ok) throw new Error("solution workload unavailable");
  return res.json();
}

/**
 * Story 1-4 unified workload chart data: trailing actuals, forward guidance,
 * and the Intensity expected-hours benchmark for a single Solution.
 */
export function useSolutionWorkload(solutionId: string) {
  return useQuery<SolutionWorkloadPayload>({
    queryKey: solutionWorkloadKeys.detail(solutionId),
    queryFn: () => fetchSolutionWorkload(solutionId),
    enabled: Boolean(solutionId),
    staleTime: 5 * 60 * 1000,
  });
}
